// columns.js
export const educatorColumns = [
  { key: "app", label: "APP NAME", type: "app" },
  { key: "educator", label: "EDUCATOR(S)", type: "educator" },
  { key: "grade", label: "GRADE(S)", type: "text" },
  { key: "adopt", label: "ADOPT. COUNT", type: "adopt" },
  { key: "date", label: "LAST UPDATED", type: "text" },
  { key: "location", label: "LOCATION", type: "text" },
  { key: "status", label: "STATUS", type: "status" },
  {
    key: "action",
    label: "ACTION",
    type: "actions",
    showView: true, // ✅ Educators get View
  },
];

export const subjectColumns = [
  { key: "app", label: "APP NAME", type: "app" },
  { key: "subject", label: "SUBJECT(S)", type: "subject" },
  { key: "grade", label: "GRADE(S)", type: "text" },
  { key: "adopt", label: "ADOPT. COUNT", type: "adopt" },
  { key: "date", label: "LAST UPDATED", type: "text" },
  { key: "location", label: "LOCATION", type: "text" },
  { key: "status", label: "STATUS", type: "status" },
  {
    key: "action",
    label: "ACTION",
    type: "actions",
    showView: false, // ❌ Subjects hide View
  },
];


export const educatorColumnstable = [
    {
        app: "Math Master",
        subject: "Math",
        educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Active",
    },
    {
        app: "Math Master",
        subject: "Math",
        educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Active",
    },

    {
        app: "Science Quest",
        subject: "Science",
        educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Inactive",
    },
    {
        app: "History Explorer",
        subject: "History",
        educator: "Mark Davis",
        grade: "9-12",
        adopt: 180,
        date: "15 Aug 2025",
        location: "Texas, USA",
        status: "Active",
    },
];

export const subjectColumnstable = [
    {
        app: "Math Master",
        subject: "Math",
        // educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Active",
    },
      {
        app: "Math Master",
        subject: "Math",
        // educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Active",
    },

    {
        app: "Science Quest",
        subject: "Science",
        // educator: "Sarah Johnson",
        grade: "6-8",
        adopt: 245,
        date: "10 Aug 2025",
        location: "California, USA",
        status: "Inactive",
    },
    {
        app: "History Explorer",
        subject: "History",
        // educator: "Mark Davis",
        grade: "9-12",
        adopt: 180,
        date: "15 Aug 2025",
        location: "Texas, USA",
        status: "Active",
    },
    // ...
];